import PropTypes from 'prop-types';
import React from 'react';
import {subjects} from "./donorProfileConstants.js";

export class DonorProfileHeader extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	renderFavoriteSubject(){
		if(this.props.favoriteSubject){
			let photoUrl = "../images/donorpage/subjecticons/icon-" + subjects[this.props.favoriteSubject].iconValue + ".png"
			return (
				<div className="col col3 donor-stat">
					<div className="donor-image-wrapper">
						<span>
							<img src={photoUrl} className="donor-stat-image"/>
						</span>
					</div>
					<div className="donor-stat-text">
						<h3>{this.props.favoriteSubject}</h3>
						<p>Favorite subject</p>
					</div>
				</div>
			)
		}
	}

	renderFavoriteState(){
		if(this.props.favoriteState){
			let state = this.props.favoriteState.replace(" ", "-").toLowerCase();
			let photoUrl = "../images/donorpage/states/icon-state-" + state + ".png"
			return (
				<div className="col col3 donor-stat">
					<div className="donor-image-wrapper">
						<span>
							<img src={photoUrl} className="donor-stat-image"/>
						</span>
					</div>
					<div className="donor-stat-text">
						<h3>{this.props.favoriteState}</h3>
						<p>Favorite state</p>
					</div>
				</div>
			)
		}
	}

	render() {
		let props = this.props
		return (
				<section className="donor-profile-header">
					<div className="container">
						<div className="fluid-container">
							<div className="col col6 donor-info-wrapper">
								<div className="donor-info">
									<img src={props.photoURL} className="donor-image"/>
									<div className="donor-info-text">
										<h1>{props.displayName}</h1>
										<h3 className="donor-stat-projects">{props.numProjectsSupported} {props.numProjectsSupported > 1 ? "projects": "project"} supported</h3>
										<p>{props.location}</p>
										<p>Joined in {props.yearJoined}</p>
										<a className="button-secondary small button-overlay button-share" onClick={props.showShareLightBox}>Share</a>
									</div>
								</div>
							</div>
							{this.renderFavoriteSubject()}
							{this.renderFavoriteState()}
						</div>
					</div>
				</section>
		);
	}
}

DonorProfileHeader.propTypes = {
	displayName: PropTypes.string.isRequired,
	numProjectsSupported: PropTypes.number.isRequired,
	location: PropTypes.string.isRequired,
	yearJoined: PropTypes.string.isRequired,
	favoriteSubject: PropTypes.string,
	favoriteState: PropTypes.string,
	photoURL: PropTypes.string,
	showShareLightBox: PropTypes.func.isRequired
};
